import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ProtectedLayout from 'components/layouts/ProtectedLayout';
import UnProtectedLayout from 'components/layouts/UnProtectedLayout';
import { routes } from 'utils/common/routes';
import { LocalStorageKey } from 'utils/common/const';
const Whitelist = lazy(() => import('components/Settings/Whitelist'));
const HomePage = lazy(() => import('pages/Home'));
const SignInPage = lazy(() => import('pages/Auth/SignIn'));
const SignOutPage = lazy(() => import('pages/Auth/SignOut'));
const UsersPage = lazy(() => import('pages/Users'));
const MatchesPage = lazy(() => import('pages/Matches'));
const PredictionsPage = lazy(() => import('pages/Predictions'));
const PredictionResultPage = lazy(() => import('pages/PredictionResult'));
const TeamsPage = lazy(() => import('pages/Teams'));
const PlayersPage = lazy(() => import('pages/Players'));
const TeamPredictionsPage = lazy(() => import('pages/TeamPredictions'));
const PlayerPredictionsPage = lazy(() => import('pages/PlayerPredictions'));
const WorldCupResultsPage = lazy(() => import('pages/WorldCupResult'));
const SettingsPage = lazy(() => import('pages/Settings'));
const PageError = lazy(() => import('pages/Error'));

const AppRoutes = () => {
  const navigate = useNavigate();
  const access_token = localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);

  useEffect(() => {
    if (!access_token) navigate(routes.signin);
  }, [access_token]);

  return (
    <Routes>
      <Route path="/" element={<ProtectedLayout />}>
        <Route index element={<HomePage />} />
        <Route path={routes.home} element={<HomePage />} />
        <Route path={routes.users} element={<UsersPage />} />
        <Route path={routes.matches} element={<MatchesPage />} />
        <Route path={routes.prediction} element={<PredictionsPage />} />
        <Route path={routes.predictionResult} element={<PredictionResultPage />} />
        <Route path={routes.teams} element={<TeamsPage />} />
        <Route path={routes.players} element={<PlayersPage />} />
        <Route path={routes.wc2026Teams} element={<TeamPredictionsPage />} />
        <Route path={routes.wc2026Players} element={<PlayerPredictionsPage />} />
        <Route path={routes.wc2026Results} element={<WorldCupResultsPage />} />
        <Route path={routes.settings} element={<SettingsPage />} />
        <Route path={routes.whitelist} element={<Whitelist />} />
      </Route>
      <Route path="/" element={<UnProtectedLayout />}>
        <Route path={routes.signin} element={<SignInPage />} />
        <Route path={routes.signout} element={<SignOutPage />} />
      </Route>
      <Route path="*" element={<PageError />} />
    </Routes>
  );
};

export default AppRoutes;
